import styled, { css } from "styled-components";
import { media } from "../styles/media"; // 생성한 미디어 쿼리 헬퍼 가져오기


/******************************************************************/
/************************ 각 메뉴 선택 영역 ************************/
/******************************************************************/

// 메뉴 선택 영역
export const MenuArea = styled.div`
    display: inline-flex;
    padding: 8px;
    margin-bottom: 10px;
    align-items: center;

    // border-bottom: 1px solid var(--Grayscale-GR_EB, #EBEBEB);

    /* 태블릿 배치 */
    ${media.tablet`
        // border-bottom: 1px solid var(--Blue, #3379EB);
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 메뉴 선택 프레임
export const MenuFrame = styled.div`
    display: flex;
    padding: 0 10px 3px 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 9px;

    border-radius: 4px;

    // /* 🔑 절대 배치 유지 */
    // position: absolute;     

    // /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    // top: 35.1%;     // 274/780 = 0.351
    // left: 2.5%;    // 20/360 = 0.055

    margin-left: 5px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 메뉴 텍스트
export const MenuText = styled.span<{ isSelected: boolean }>`
    // color: var(--Blue, #3379EB);
    color: var(--Grayscale-BK_00, #000);
    /* isSelected prop이 true일 때만 색상 변경 */
    ${(props) => props.isSelected && css`
        color: var(--Blue, #3379EB);
    `}
    text-align: center;

    /* mobile/caption1_M */
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 14px; /* 116.667% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 메뉴 아이콘
export const MenuIcon = styled.div`
    width: 24px;
    height: 24px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

export const MainTabContainer = styled.div`
    justify-items: center; /* 가운데 정렬 */
    text-align: center;

`;
// only tablet, desktop
// 태블릿용 그리드 UI
// 2개의 탭을 한 줄에 배치하기 위한 컨테이너 
export const MainTabGridContainer = styled.div`
    display: grid;
    gap: 14px;

    justify-items: center; /* 가운데 정렬 */
    grid-template-columns: repeat(2, 1fr);

`;

export const TabGridContainer = styled.div`
    display: grid;
    gap: 14px;

    width: 100%;
    justify-items: center; /* 가운데 정렬 */
    grid-template-columns: 460px 460px; 
    align-items: start;

    grid-template-columns: repeat(2, 1fr);
    ${media.tablet`
    `}
    @media (max-width: 1024px) {
        /* 필요에 따라 1024px 이하에서는 1줄에 1개로 변경할 수도 있습니다. */
    }  
`;

export const TabGridContainer2 = styled.div`
    display: grid;
    gap: 14px;

    width: 100%;    
    justify-items: center; /* 가운데 정렬 */
    grid-template-columns: 460px 460px; 
    align-items: start;

    grid-template-columns: repeat(2, 1fr);
    ${media.tablet`
    `}
    @media (max-width: 1024px) {
        /* 필요에 따라 1024px 이하에서는 1줄에 1개로 변경할 수도 있습니다. */
    }  
`;
/////////////////////////////////////////////////////


/******************************************************************/
/********************* 각 메뉴 백그라운드, 타이틀********************/
/******************************************************************/

// 각 메뉴 공통 백그라운드
export const CommonMenuArea = styled.div<{ isMenuSelected?: boolean }>`
    width: 330px;
    height: 393px;
    flex-shrink: 0;

    border-radius: 16px;
    background: var(--DarkNavy, #1B1F38);

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    display: flex;
    flex-direction: column; /* 세로 방향으로 요소 배치 */
    // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */
    align-items: center; /* 가운데 정렬 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 310px;
        height: 400px;
        border-radius: 24px;
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#1B1F38' : '#f5ececff'};
        // f8ebebff
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 450px;          
        height: 400px;
        border-radius: 24px;
    `}     
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#1B1F38' : '#FFF'};
    `}       
`;

// only tablet, desktop
// 각 메뉴 공통 타이틀 프레임
/**
 *  CommonMenuTitle
 *  ㄴ CommonMenuTitleIcon
 *  ㄴ CommonMenuTitleText
 */
export const CommonMenuTitle = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    /* 태블릿 배치 */
    ${media.tablet`
        /* 🔑 절대 배치 유지 */
        position: absolute;           
        top: calc(24/400 * 100%);
        left: calc(65/460 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        /* 🔑 절대 배치 유지 */
        position: absolute;           
        top: calc(24/400 * 100%);
        left: calc(130/460 * 100%);
    `}        
`;

// only tablet, desktop
// 각 메뉴 공통 타이틀 아이콘
export const CommonMenuTitleIcon = styled.span<{ 
    isMenuSelected: boolean;
    $menuUrl: string; 
    $selectedMenuUrl: string;
}>`

    width: 24px;
    height: 24px;

    background-image: url(${(props) => props.$menuUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected, $menuUrl, $selectedMenuUrl }) => media.tablet`
        background-image: url("${isMenuSelected ? $selectedMenuUrl : $menuUrl}");
    `}    

    /* Desktop 배치 */
    ${media.desktop`

    `}
    ${({ isMenuSelected, $menuUrl, $selectedMenuUrl }) => media.desktop`
        background-image: url("${isMenuSelected ? $selectedMenuUrl : $menuUrl}");
    `}               
`;

// only tablet, desktop
// 각 메뉴 공통 타이틀 텍스트
export const CommonMenuTitleText = styled.span<{ isMenuSelected: boolean }>`
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;
    justify-content: center;

    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(24/393 * 100%);
    left: calc(105/328 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 22px;
        line-height: 26px; /* 116.667% */

        /* 1. position 속성 해제 (absolute -> static 또는 relative) */
        position: static; 
        
        /* 2. top/left 속성 해제 */
        top: initial;
        left: initial;
        /* 또는 top: unset; left: unset; 도 사용 가능합니다. */  
    `}

    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* 데스크톱 배치 */
    ${media.desktop`
        font-size: 24px;
        line-height: 28px; /* 116.667% */

        /* 1. position 속성 해제 (absolute -> static 또는 relative) */
        position: static; 
        
        /* 2. top/left 속성 해제 */
        top: initial;
        left: initial;
        /* 또는 top: unset; left: unset; 도 사용 가능합니다. */  
    `}

    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

/******************************************************************/
/************************ LED 제어 설정 탭 ************************/
/******************************************************************/

// LED 제어 선택 프레임
/**
 *  LedControlSelectFrame
 *  ㄴ LedControlSelectFocus
 *     ㄴ LedControlSelectFocusText
 */
export const LedControlSelectFrame = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(69/393 * 100%);
    left: calc(16/328 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        left: calc(22/328 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        left: 18%;
        // left: calc(16/328 * 100%);
    `}    
`;

// LED 제어 선택 포커스
export const LedControlSelectFocus = styled.div<{ isSelected: boolean }>`
    display: flex;
    width: 96px;
    height: 72px;
    padding: 25px 30.5px 23px 33.5px;
    justify-content: center;
    align-items: center;

    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);

    ${(props) => props.isSelected && css`
        border-radius: 8px;
        border: 2px solid var(--NeonGreen, #85F2A6);
    `}    


    /* 태블릿 배치 */
    ${media.tablet`
        width: 86px;
    `}
    ${({ isSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 96px;
    `}
    ${({ isSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// LED 제어 선택 포커스 텍스트
export const LedControlSelectFocusText = styled.span<{ isSelected: boolean; isMenuSelected: boolean }>`
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    /* mobile/title1_R */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 120% */

    ${(props) => props.isSelected && css`
        color: var(--NeonGreen, #85F2A6);
        text-align: center;

        /* mobile/title1 */
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
    `}        

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// LED 밝기 선택 프레임
/**
 * 
 */
export const LedBrightFrame = styled.div`
    display: flex;
    width: 312px;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(173/393 * 100%);
    left: calc(8/328 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 282px;
        left: calc(14/460 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 312px;
        left: calc(74/460 * 100%);
    `}    
`;

// LED 밝기 선택 텍스트 프레임
export const LedBrightTextFrame = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// LED 밝기 텍스트 1
export const LedBrightText1 = styled.label<{isMenuSelected: boolean }>`
    // color: var(--Grayscale-WT_FF, #FFF);
    color: ${(props) => props.isMenuSelected ? '#FFF' : '#0D0F22'};
    text-align: center;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 114.286% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 20px;
        font-weight: 500;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}
    
    /* Desktop 배치 */
    ${media.desktop`
        font-size: 22px;
        font-weight: 500;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}	    
`;

// LED 밝기 텍스트 2
export const LedBrightText2 = styled.output<{isMenuSelected: boolean }>`
    // color: var(--Grayscale-WT_FF, #FFF);
    color: ${(props) => props.isMenuSelected ? '#FFF' : '#0D0F22'};
    text-align: center;

    font-family: Roboto;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px; /* 108.333% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}	

    /* Desktop 배치 */
    ${media.desktop`

    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}	    
`;

// LED 밝기 프로그래스 영역 프레임
export const LedBrightProgressFrame = styled.div`
    display: flex;
    padding: 0 24px 8px 40px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// LED 밝기 프로그래스 양옆 텍스트
export const LedBrightProgressText = styled.span<{ isMenuSelected: boolean }>`
    // color: var(--Grayscale-WT_FF, #FFF);
    color: ${(props) => props.isMenuSelected ? '#FFF' : '#0D0F22'};
    text-align: center;

    /* mobile/body2_R */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 114.286% */
    

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// 공통 프로그래스 바 프레임
export const CommonProgressBarFrame = styled.div`
    width: 160px;
    height: 32px;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 165px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 200px;
    `}    
`;

// 공통 프로그래스 바
export const CommonProgressBar = styled.div`
    width: 160px;
    height: 6px;
    flex-shrink: 0;

    fill: #0D0F22;


    /* 태블릿 배치 */
    ${media.tablet`
        width: 165px;
        height: 32px;

    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 200px;
    `}    
`;

// 공통 프로그래스 바 커서
export const CommonProgressBarCursor = styled.input.attrs({
    type: 'range',
})<{ $cursorUrl: string; level: number }>`
    width: 160px;
    height: 6px;
    flex-shrink: 0;

    // 🔑 -webkit-appearance를 여기서 초기화하여 그라데이션이 적용되도록 합니다.
    -webkit-appearance: none;
    background: transparent;
    cursor: pointer;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 165px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 200px;
    `}  

    /* ---------------------------------------------------- */
    /* 트랙과 채워진 부분의 동적 배경색 설정 */
    ${(props) => {
        const fillPercent = props.level; // 1부터 100 사이의 값이라고 가정
        const greenColor = 'var(--NeonGreen, #85F2A6)';
        const trackColor = '#e0e0e0'; // 채워지지 않은 부분의 색상 (회색)

        return css`
            /* WebKit (Chrome, Safari) 용 트랙 */
            &::-webkit-slider-runnable-track {
                height: 6px;
                border-radius: 3px;
                
                /* 🔑 선형 그라데이션으로 배경을 채웁니다. */
                /* 시작 지점부터 fillPercent까지는 NeonGreen, 그 다음부터는 트랙 색상 */
                background: linear-gradient(
                    to right,
                    ${greenColor} 0%, 
                    ${greenColor} ${fillPercent}%, 
                    ${trackColor} ${fillPercent}%, 
                    ${trackColor} 100%
                );
            }
            
            /* Firefox 용 트랙 (별도 설정이 필요할 수 있습니다. 여기서는 생략) */
            /* ... */
        `;
    }}

    /* ---------------------------------------------------- */

    /* 🔑 썸(Thumb) 스타일링: 커스텀 SVG 배경 이미지 적용 */
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        -moz-appearance: none;    /* Firefox 호환성 추가 */
        
        /* SVG 크기에 맞춰 width/height 지정 (예: 32px) */
        width: 32px;
        height: 32px;

        background-size: 32px 32px; 
       
        /* 💡 인코딩된 SVG를 배경 이미지로 사용 */
        background-image: url(${(props) => props.$cursorUrl}); 
        background-size: cover;
        // 👇 이 세 줄을 추가해 주세요!
        background-repeat: no-repeat;
        background-size: contain; /* 또는 cover, 100% auto 등 */
        background-position: center;         

        /* 트랙 중앙에 오도록 위치 조정 (썸 크기의 절반 - 트랙 높이의 절반) */
        margin-top: calc(-32px / 2 + 6px / 2);    

  
`;

// 공통 우측 하단 적용 버튼
export const CommonMenuConfirm = styled.button<{ isMenuSelected?: boolean }>`
    position: absolute;

    display: inline-flex;
    height: 44px;
    min-width: 120px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: 84.7%; 
    left: 50.0%;
    right: 4.9%;
    // bottom: 4.1%;
       
    border-radius: 4px;
    background: var(--NeonGreen, #85F2A6);

    color: var(--DarkNavy, #1B1F38);
    text-align: center;

    /* mobile/title2 */
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 20px;
        font-weight: 700;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#85F2A6' : '#E0E0E0'};
        color: ${isMenuSelected ? '#1B1F38' : '#999595ff'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
        font-weight: 700;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.desktop`
        background-color: ${isMenuSelected ? '#85F2A6' : '#E0E0E0'};
        color: ${isMenuSelected ? '#1B1F38' : '#999595ff'};
    `}    
`;

/******************************************************************/
/************************ 감지 센서 설정 탭 ************************/
/******************************************************************/

// 감지 센서 설정영역 프레임
/**
 * 
 */
export const SensorSetFrame = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 80vw;
    gap: 24px;

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(112/400 * 100%);
    left: calc(50/460 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        gap: 24px;
        left: calc(18/460 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        left: calc(50/460 * 100%);
    `}    
`;

// 감지 센서 프로그래스 프레임
export const SensorSetProgressFrame = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    
    /* 태블릿 배치 */
    ${media.tablet`
        gap: 10px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        gap: 20px;
    `}    
`;

// 감지 센서 프로그래서 왼쪽 텍스트
export const SensorSetProgressTextLeft = styled.span<{ isMenuSelected: boolean }>`
    width: 40px;

    text-align: right;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;

    color: #FFF;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 56px;
        font-size: 18px;
        line-height: 24px; /* 120% */        
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// 감지 센서 프로그래서 오른쪽 텍스트
export const SensorSetProgressTextRight = styled.span<{ isMenuSelected: boolean }>`
    width: 50px;

    text-align: left;

    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    color: #FFF;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 64px;
        font-size: 26px;
        line-height: 40px;       
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 36px;
    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

/******************************************************************/
/*********************** LED 동작 모드 설정 탭 *********************/
/******************************************************************/

// only tablet, desktop
// LED 동작 모드 설정 프레임
/**
 * 
 */
export const MotionSetFrame = styled.div`
    display: flex;
    width: 282px;
    padding: 12px 8px 12px 12px;
    align-items: center;
    gap: 8px;

    border-radius: 4px;
    background: rgba(255, 255, 255, 0.10);

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(76/400 * 100%);
    left: calc(34/460 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 262px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 392px;
    `}    
`;

// LED 모드 선택
export const MotionSetSelect = styled.span<{ isMenuSelected: boolean }>`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-WT_FF, #FFF);
    text-overflow: ellipsis;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 18px;
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
    
    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}        
`;

// LED 모드 선택 아이콘
export const MotionSetSelectIcon = styled.span<{ 
    isMenuSelected: boolean;
    $imgUrl: string; 
    $selectedimgUrl: string;
}>`

    width: 24px;
    height: 24px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$selectedimgUrl}); 

    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected, $imgUrl, $selectedimgUrl }) => media.tablet`
        background-image: url("${isMenuSelected ? $selectedimgUrl : $imgUrl}");
    `}     
    
    /* Desktop 배치 */
    ${media.desktop`

    `}
    ${({ isMenuSelected, $imgUrl, $selectedimgUrl }) => media.desktop`
        background-image: url("${isMenuSelected ? $selectedimgUrl : $imgUrl}");
    `}         
`;

// LED 동작 각 설정 값 프레임
/**
 * 
 */
export const MotionValueSetFrame = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    /* 🔑 절대 배치 유지 */
    position: absolute;     

    /* 🔑 부모(CommonMenuArea) 기준 위치 설정 */
    top: calc(152/400 * 100%);
    left: calc(34/460 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        left: calc(20/460 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        left: calc(34/460 * 100%);
    `}    
`;

// 동작 설정 값 Row 프레임
export const MotionValueSetRow = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;

    /* 태블릿 배치 */
    ${media.tablet`
        gap: 10px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        gap: 24px;
    `}    
`;

// 동작 설정 값 Col 프레임
export const MotionValueSetCol = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;

    /* 태블릿 배치 */
    ${media.tablet`
        gap: 4px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        gap: 16px;
    `}    
`;

// 각 동작 설정 텍스트
export const MotionValueSetText = styled.span<{ isMenuSelected: boolean }>`
    width: 60px;
    text-align: center;

    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;

    color: #FFF;

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 12px;
        line-height: 16px;        
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 14px;
    `}        
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}       
`;

// 각 설정 값 입력 프레임
export const MotionValueSetDataFrame = styled.div`

    display: flex;
    width: 64px;
    height: 48px;
    justify-content: center;
    align-items: center;

    border-bottom: 1px solid var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 68px;
        height: 60px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 108px;
        height: 60px;
    `}        
`;

// 각 설정 값 입력
export const MotionValueSetValue = styled.span<{ isMenuSelected: boolean }>`

    text-align: center;

    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    color: #FFF;

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 24px;
        line-height: 40px;
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 36px;
        line-height: 40px;
    `}        
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}        
`;


/******************************************************************/
/********************* 모드 선택 모달 컴포넌트 **********************/
/******************************************************************/

// 모드 선택 타이틀 텍스트
export const MotionModeSetListTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;

    align-self: stretch;

    color: var(--Grayscale-BK_00, #000);
    text-align: center;

    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; /* 121.429% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 목록 프레임
export const MotionModeSetListFrame = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    /* 태블릿 배치 */
    ${media.tablet`

    `} 

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 프레임
export const MotionModeSetListSelectFrame = styled.div`
    display: flex;
    width: 440px;
    height: 72px;
    padding: 8px 12px;
    align-items: flex-start;
    gap: 10px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}  

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 포커스 배경
export const MotionModeSetListSelectFocus = styled.span`
    display: flex;
    padding: 12px 12px 12px 16px;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;

    border-radius: 4px;
    background: var(--Blue_op8, rgba(51, 121, 235, 0.08));

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 언 포커스 배경
export const MotionModeSetListSelectUnFocus = styled.span`
    display: flex;
    padding: 12px 12px 12px 16px;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;


    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 포커스 텍스트
export const MotionModeSetLisSelect = styled.span`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Blue, #3379EB);
    text-overflow: ellipsis;

    /* tablet/body1_M */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
 
    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 언 포커스 텍스트
export const MotionModeSetLisUnSelect = styled.span`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-GR_22, #222);
    text-overflow: ellipsis;

    /* tablet/body1_M */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 포커스 체크 아이콘
export const MotionModeSetListSelectCheck = styled.span<{ $imgUrl: string;}>`
    width: 24px;
    height: 24px;
    
    background-image: url(${(props) => props.$imgUrl}); 
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */


    /* 태블릿 배치 */
    ${media.tablet`

    `}
 
    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 모드 선택 버튼 프레임
export const MotionModeSetModalButtonFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 모드 선택 취소 버튼
export const MotionModeSetModalCancleButton = styled.div`
    display: flex;
    width: 200px;
    height: 60px;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 4px;
    border: 1px solid var(--Grayscale-GR_EB, #EBEBEB);
    background: var(--GrayPurple, #6C739A);    

    color: var(--Grayscale-GR_EB, #EBEBEB);
    text-align: center;

    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 116.667% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 입력 프레임
export const MotionInputDataValueTimeFrame = styled.span<{ isDisabled?: boolean }>`
    /* 모바일 기본 */
    display: inline-flex;
    justify-content: flex-start;
    align-self: CENTER;
    // align-items: flex-end;
    gap: 2px;
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;

    // 💡 isDisabled 프롭에 따른 스타일 제어
    opacity: ${(props) => (props.isDisabled ? 0.4 : 1)};
    pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')}; 

    /* 태블릿 배치 */
    ${media.tablet`
        justify-content: flex-end;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        justify-content: center;
    `}    
`;

// 시간 텍스트
export const MotionInputDataValueTimeText = styled.span<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    // width: 83px;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: left;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 112.5% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 16px;
        text-align: center;
    `}
    ${({ isMenuSelected }) => media.tablet`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}
    /* Desktop 배치 */
    ${media.desktop`
        font-size: 18px;
        text-align: right;
    `}
    ${({ isMenuSelected }) => media.desktop`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}        
`;

/******************************************************************/
/********************** 월별 시간 밝기 설정 탭 **********************/
/******************************************************************/

// 월별 시간 밝기 영역 백그라운드
export const MontlyMenuArea = styled.div<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    width: 328px;
    // height: 393px;
    height: 103vh;
    flex-shrink: 0;

    border-radius: 16px;
    background: var(--DarkNavy, #1B1F38);

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    display: flex;
    flex-direction: column; /* 세로 방향으로 요소 배치 */
    // justify-content: flex-top; /* 아래쪽으로 요소를 몰아넣음 */
    align-items: center; /* 가운데 정렬 */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 330px;        
        height: 825px;
        border-radius: 24px;

        margin: 0 auto;
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#1B1F38' : '#FFF'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 450px;       
        height: 880px;
        border-radius: 24px;

        margin: 0 auto;
    `}    
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#1B1F38' : '#FFF'};
    `}
`;

// 월별 선택 스크롤 프레임
/**
 * 
 */
export const MontlyTabScrollFrame = styled.div`
    /* 모바일 기본 */
    display: inline-flex;
    justify-content: flex-end;
    // flex-direction: column;
    align-items: center;

    position: absolute;           
    top: 10%;
    left: -9%; 

    /* 태블릿 배치 */
    ${media.tablet`
        flex-direction: column;
        align-items: center;

        /* 🔑 절대 배치 유지 */
        position: absolute;           
        top: calc(86/830 * 100%);
        left: calc(-10/460 * 100%); 
        bottom: calc(98/830 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        flex-direction: column;
        align-items: center;

        /* 🔑 절대 배치 유지 */
        position: absolute;           
        top: calc(76/830 * 100%);
        left: calc(24/460 * 100%); 
        bottom: calc(98/830 * 100%);
    `}    
`;

// 월별 목록 프레임
export const MontlyTabListFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    /* -------------------------------------- */
    /* 🔑 스크롤 기능 추가 속성 */
    /* -------------------------------------- */
    /* 1. 높이 제한: 스크롤이 발생하려면 고정된 높이가 필요합니다. */
    /* (이 예시에서는 임의의 높이 200px을 설정합니다. 프로젝트에 맞게 % 또는 vw/vh 사용) */
    // height: 700px; 
    height: 80vh; 
    
    /* 2. 넘치는 콘텐츠 처리: 콘텐츠가 이 높이를 초과하면 스크롤바를 표시합니다. */
    overflow-y: auto; 
    // overflow-y: scroll;
    /* overflow-y: scroll; 은 항상 스크롤바를 표시합니다. auto는 넘칠 때만 표시합니다. */
    
    /* 3. 내부 요소 배치: 세로 스크롤 시 내부 요소가 줄바꿈되지 않도록 nowrap 설정 */
    flex-wrap: nowrap; 

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 월별 프레임
export const MontlyTabFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 72px;
    height: 54px;
    padding-top: 8px;
    margin-left: 14px;
    padding-left: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 88px;
        height: 64px;
        margin-left: 1px;
        padding-left: 1px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 88px;
        height: 64px; 
        margin-left: 1px;
        padding-left: 1px;
    `}    
`;

// 선택 월 포커스
export const MontlyTabFocus = styled.div`
    /* 모바일 기본 */
    display: flex;
    // padding-right: 12px;
    justify-content: center;
    // align-items: center;
    gap: 10px;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 선택 월 포커스 하단 라인
export const MontlyTabFocusLine = styled.div`
    /* 모바일 기본 */
    width: 2px;
    height: 40px;
    transform: rotate(-90deg);
    flex-shrink: 0;

    border-radius: 12px;
    background: var(--Grayscale-BK_00, #85F2A6);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// 각 월 텍스트
export const MontlyTabText = styled.div<{ isSelected: boolean; isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    width: 48px;
    flex-shrink: 0;

    // color: var(--Grayscale-GR_66, #666);
    text-align: right;

    font-family: Roboto;
    // font-size: 20px;
    font-style: normal;
    // font-weight: 400;
    // line-height: 24px; /* 120% */

    color: ${({ isSelected }) => (isSelected ? '#85F2A6' : '#666')}; 
    font-size: ${({ isSelected }) => (isSelected ? '22px' : '18px')}; 
    font-weight: ${({ isSelected }) => (isSelected ? '500' : '400')}; 
    line-height: ${({ isSelected }) => (isSelected ? '26px' : '24px')}; 

    /* 태블릿 배치 */
    ${media.tablet`
        width: 52px;
    `}
    ${({ isMenuSelected }) => media.tablet`
        // color: ${isMenuSelected ? 'var(--NeonGreen, #85F2A6)' : 'var(--Grayscale-GR_66, #666)'};


        /* tablet/title2_M */
        // font-size: ${isMenuSelected ? '24px' : '20px'};
        // font-weight: ${isMenuSelected ? '500' : '400'};
        // line-height: ${isMenuSelected ? '28px' : '24px'}; /* 116.667% */

        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        // background-color: ${isMenuSelected ? '#85F2A6' : '#666'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 52px;
    `}      
`;

// 월 시간별 입력란 프레임
/**
 * 
 */
export const MontlyInputFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 295px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 195px;    
        /* 🔑 절대 배치 유지 */
        position: absolute;           
        top: calc(26/830 * 100%);
        left: calc(541/460 * 100%); 
        // right: calc(24/460 * 100%); 
        // bottom: calc(98/830 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 295px;
    `}    
`;

// 월 시간별 값 입력 프레임
// 보류
export const MontlyInputDataFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 295px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 데이터 입력 타이틀 프레임
export const MontlyInputDataTitleFrame = styled.div`
    /* 모바일 기본 */
    display: grid;
    width: 295px;
    height: 28px;
    padding-left: 20px;
    column-gap: 10px;
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns: 110.00px minmax(0, 1fr) 40.00px;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 250px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 295px;
        padding-left: 20px;        
    `}    
`;

// 시간 데이터 입력 타이틀 왼쪽 텍스트
export const MontlyInputDataTitleLeft = styled.div<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    align-self: CENTER;
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
    justify-self: CENTER;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected }) => media.tablet`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}    
    ${({ isMenuSelected }) => media.desktop`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// 시간 데이터 입력 타이틀 오른쪽 텍스트
export const MontlyInputDataTitleRight = styled.div<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    align-self: CENTER;
    grid-row: 1 / span 1;
    grid-column: 2 / span 1;
    justify-self: CENTER;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    ${({ isMenuSelected }) => media.tablet`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}    
    ${({ isMenuSelected }) => media.desktop`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    
`;

// 시간 및 밝기 입력 프레임
/**
 * 
 */
export const MontlyInputDataValueFrame = styled.div`
    /* 모바일 기본 */
    display: grid;
    // width: 295px;
    height: 56px;
    // padding: 0 4px 0 20px;
    row-gap: 10px;
    column-gap: 10px;
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns:    110.00px minmax(0, 1fr) 40.00px;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 250px;
        padding: 0 4px 0 8px;        
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 295px;
        padding: 0 4px 0 20px;        
    `}    
`;

// 시간 입력 프레임
export const MontlyInputDataValueTimeFrame = styled.span`
    /* 모바일 기본 */
    display: inline-flex;
    justify-content: flex-start;
    align-self: CENTER;
    // align-items: flex-end;
    gap: 2px;
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;

    /* 태블릿 배치 */
    ${media.tablet`
        justify-content: flex-end;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        justify-content: center;
    `}    
`;

// 시간 텍스트
export const MontlyInputDataValueTimeText = styled.span<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    width: 83px;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: right;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 112.5% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 16px;
        text-align: center;
    `}
    ${({ isMenuSelected }) => media.tablet`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}
    /* Desktop 배치 */
    ${media.desktop`
        font-size: 18px;
        text-align: right;
    `}
    ${({ isMenuSelected }) => media.desktop`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}        
`;

// 밝기 값
export const MontlyInputDataValueBright = styled.span<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    width: 56px;
    align-self: CENTER;
    grid-row: 1 / span 1;
    grid-column: 2 / span 1;
    justify-self: CENTER;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: right;

    font-family: Roboto;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 112.5% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 24px;
        text-align: center;
    `}
    ${({ isMenuSelected }) => media.tablet`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}    

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 30px;
    `}
    ${({ isMenuSelected }) => media.desktop`
        color: ${isMenuSelected ? '#FFF' : '#0D0F22'};
    `}        
`;

// 각 입력 라인 삭제 버튼
export const MontlyInputDataValueDelete = styled.span<{$imgUrl: string;}>`
    /* 모바일 기본 */
    display: flex;
    width: 32px;
    height: 32px;
    padding: 10px;
    align-self: CENTER;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    grid-row: 1 / span 1;
    grid-column: 3 / span 1;
    justify-self: center;

    border-radius: 4px;
    background: rgba(255, 255, 255, 0.04);

    background-image: url(${(props) => props.$imgUrl}); 
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */    

    /* 태블릿 배치 */
    ${media.tablet`
        width: 28px;
        padding: 2px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 32px;
        padding: 10px;
    `}    
`;

// 각 입력 라인 하단 라인 프레임
export const MontlyInputDataValueLineFrame = styled.span`
    /* 모바일 기본 */
    display: flex;
    height: 1px;
    padding-left: 18px;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`
        padding-left: 0px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        padding-left: 12px;
    `}    
`;

// 각 입력 라인 하단 라인
export const MontlyInputDataValueLine = styled.span`
    /* 모바일 기본 */
    height: 0.4px;
    flex: 1 0 0;

    opacity: 0.2;
    background: var(--Grayscale-WT_FF, #FFF);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 입력 라인 추가 버튼 프레임
export const MontlyInputDataValueAdd = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 120px;
    height: 40px;
    padding: 14px 0;
    align-self: CENTER;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 4px;
    background: rgba(255, 255, 255, 0.04);
 

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 입력 라인 추가 버튼 아이콘
export const MontlyInputDataValueAddIcon = styled.span<{$imgUrl: string;}>`
    /* 모바일 기본 */
    width: 12px;
    height: 12px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$imgUrl}); 
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */    

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 입력 라인 추가 버튼 텍스트
export const MontlyInputDataValueAddText = styled.span`
    /* 모바일 기본 */
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    /* tablet/body1_M */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;


// 월별 시간 밝기 설정 버튼
export const MonthlyConfirm = styled.button<{ isMenuSelected?: boolean }>`
    /* 모바일 기본 */
    display: inline-flex;
    height: 44px;
    min-width: 120px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    position: absolute;
    
    calc(76/830 * 100%);
    top: calc(754/830 * 100%); //84.7%; 
    left: calc(266/460 * 100%); //58.5%;

    border-radius: 4px;
    background: var(--NeonGreen, #85F2A6);

    color: var(--DarkNavy, #1B1F38);
    text-align: center;

    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */

    /* 태블릿 배치 */
    ${media.tablet`
        left: calc(265/460 * 100%); //58.5%;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.tablet`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#85F2A6' : '#E0E0E0'};
        color: ${isMenuSelected ? '#1B1F38' : '#999595ff'};
    `}

    /* Desktop 배치 */
    ${media.desktop`
        left: calc(316/460 * 100%); //58.5%;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px; /* 120% */
    `}
    ${({ isMenuSelected }) => media.desktop`
        /* 👇 선택되었을 때 (isActive) 배경색 변경 */
        background-color: ${isMenuSelected ? '#85F2A6' : '#E0E0E0'};
        color: ${isMenuSelected ? '#1B1F38' : '#999595ff'};
    `}    
`;


// 시간 및 밝기 버튼 프레임
export const MonthlyModalButtonFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 및 밝기 설정 버튼
export const MonthlyModalConfirmButton = styled.div`
    display: flex;
    width: 180px;
    height: 60px;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 4px;
    border: 1px solid var(--Grayscale-GR_EB, #EBEBEB);
    background: var(--GrayPurple, #6C739A);    

    color: var(--Grayscale-GR_EB, #EBEBEB);
    text-align: center;

    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 116.667% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 및 밝기 취소 버튼
export const MonthlyModalCancleButton = styled.div`
    display: flex;
    width: 180px;
    height: 60px;
    padding: 12px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 4px;
    border: 1px solid var(--Grayscale-GR_EB, #6C739A);
    background: var(--GrayPurple, #f7f1f1ff);    

    color: var(--Grayscale-GR_EB, #121314ff);
    text-align: center;

    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px; /* 116.667% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 설정 타임 피커 컨테이너
export const MonthlyModalTimepickerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 설정 타임 피커 프레임
export const MonthlyModalTimepickerFrame = styled.div`
    width: 380px;
    height: 210px;

    border-radius: 4px;
    background: var(--DarkNavy, #1B1F38);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 설정 타임 피커 시간 프레임
export const MonthlyModalTimepickerTimeFrame = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;

    margin-left: 35px;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 설정 타임 피커 시간 텍스트
export const MonthlyModalTimepickerTimeText = styled.div`
    display: flex;
    width: 80px;
    height: 64px;
    flex-direction: column;
    justify-content: center;

    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    /* tablet/H2 */
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 111.111% */

    // opacity: 0.4;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 시간 설정 타임 피커 시간 설정 버튼
export const MonthlyModalTimepickerButton = styled.button`
    display: flex;
    width: 80px;
    height: 64px;    
    flex-direction: column;
    justify-content: center;
    color: var(--Grayscale-WT_FF, #FFF);
    text-align: center;

    font-size: 20px;
    background: none;
    border: none;
    cursor: pointer;
`;

// 시간 설정 타임 피커 시간 텍스트 하단 라인
export const MonthlyModalTimepickerTimeLine = styled.div`
    width: 80px;
    height: 2px;
    flex-shrink: 0;

    background: var(--NeonGreen, #85F2A6);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;
